import React from "react";
import { LeftArrowIcon } from "staysure-component-library";

import BtnLoadingSvg from "@/components/atoms/btn-loading-svg/btn-loading-svg";

import Styles from "./action-button.module.css";
import useFooterHook from "./footer.hook";
import LabelButtonWrapper, {
  IconButtonWrapper,
} from "../button-wrapper/button-wrapper";
import { FooterType } from "./types/footer.type";
import FadeAnimation from "../animation/fade-animation";

function Footer({
  brand = "staysure",
  ctaButtonText = "Agree and Continue",
  footerAnimationRef = undefined,
  footerRef = undefined,
  id = "cover-type",
  isDisabledBack = false,
  isDisabledContinue = false,
  isHideFooterBack = false,
  isLoading = false,
  footerActionBack,
  footerActionContinue,
}: Readonly<FooterType>) {
  const { getButtonStyle } = useFooterHook({ id });
  return (
    <div id={id} className="lg:mt-spacing-xl">
      <FadeAnimation animationRef={footerAnimationRef}>
        <div
          className={`flex fixed left-0 bottom-0 bg-surface-neutral-option-1 w-full px-spacing-l ${
            isHideFooterBack ? "lg:max-w-[342px]" : "lg:max-w-[414px]"
          } mx-auto py-spacing-s lg:py-[0px]
    shadow-[0_4px_4px_0px_#00000040] md:fixed lg:relative lg:shadow-none lg:bg-transparent z-[8] !bg-interactive-overlay-image md:justify-center md:!px-0`}
          data-testid="action-button-id"
          ref={footerRef}
        >
          <div className=" backdrop-blur-[1.5px] md:hidden absolute h-full w-full z-[1] top-[1px] bottom-[1px]" />
          {!isHideFooterBack && (
            <IconButtonWrapper
              id={`${id}-page-back-button`}
              aria-label="Back"
              btnType="icon"
              icon={
                <LeftArrowIcon
                  brand={brand}
                  stroke={isDisabledBack ? "#D2D2D2" : undefined}
                />
              }
              hierarchy="secondary"
              className={`${Styles.icon_btn} ${Styles.back_button} md:mr-spacing-m mr-spacing-s z-[2] relative w-full max-w-[56px] h-[56px] rounded-radius-pill hover:!bg-interactive-action-hovered`}
              onClick={footerActionBack}
              isDisabled={isDisabledBack}
            />
          )}

          <LabelButtonWrapper
            id={`${id}-page-submit-button`}
            data-testid={`${id}-page-submit-button`}
            isDisabled={isDisabledContinue}
            label={ctaButtonText}
            isLoading={isLoading}
            loadingIcon={isLoading ? <BtnLoadingSvg /> : <div />}
            hierarchy="primary"
            className={getButtonStyle(id ?? "", isDisabledContinue)}
            type="button"
            onClick={footerActionContinue}
          />
        </div>
      </FadeAnimation>
    </div>
  );
}

export default Footer;
